// src/App.tsx
import { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContextProvider, NotificationProvider } from 'src/contexts';
import AppRouter from './routes/AppRouter';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DashboardProvider } from './contexts/DashboardContext';
import { CampaignProvider } from './contexts/CampaignContext';
import { AudienceProvider } from './contexts/AudienceContext';
import { CreativeProvider } from './contexts/CreativeContext';

export default function App() {
  const navigate = useNavigate();

  return (
    <AuthContextProvider>
      <NotificationProvider>
        <ToastContainer />
        <DashboardProvider>
          <CampaignProvider>
            <AudienceProvider>
              <CreativeProvider>

                <AppRouter />

              </CreativeProvider>
            </AudienceProvider>
          </CampaignProvider>
        </DashboardProvider>
      </NotificationProvider>
    </AuthContextProvider>
  );
}